module.exports = __webpack_public_path__ + "img/loader.049a46db.gif";